module.exports = __webpack_public_path__ + "media/images/icons/profile-786e68bbf5d520ea2576ca7ece19670b.svg";